import { Deserializable } from '../deserializable';
import { AccountDetails } from './account-details';

export class ProgressReport implements Deserializable {
  total: number;
  percentComplete: number;
  processedCount: number;
  errors: string[];
  details: AccountDetails[];
  startTime: Date;
  endTime?: Date;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
